import { useRouter } from 'next/router';
import React from 'react';

import { useNavigationMenu } from '../../hooks/Navigation';
import { Header } from './Header';

export const CONTENTS_EXPERIMENT_KEY = 641;
export const CONTENTS_EXPERIMENT_TYPE = {
  LEGACY: 'A',
  NEW: 'B',
};

export const HeaderContainer = ({
  hideGnbInSSR,
}: {
  hideGnbInSSR?: boolean;
}): React.ReactElement | null => {
  const router = useRouter();
  const { data: navigationMenu, error } = useNavigationMenu(router.pathname);

  if (error || !navigationMenu) {
    return null;
  }

  return <Header hideGnbInSSR={hideGnbInSSR} />;
};
